import MtnZAService from "@/services/mtnZAService";

const ENTITLED_STATUS_NAMES = new Set(['ACTIVE', 'GRACE', 'SUSPENDED']);

const SIGNED_PARAM_NAMES = [
    'sigts', 'sigv1',
    'depserviceid', 'bpSvc', 'msisdn', 'result', 'result_id',
    'subscription_id', 'channel', 'ext_ref',
];

export function isMyBundleEntry(rawQueryString = window.location.search) {
    return /[?&]sigv1=/.test(rawQueryString);
}

export async function handleMyBundleEntry(productId) {
    const response = await MtnZAService.validateMyBundleEntry(productId, window.location.search);
    const data = response?.data;

    stripSignedParams();

    if (!data?.result) {
        console.log(`My Bundle entry rejected: ${data?.reason ?? 'REQUEST_FAILED'}`);
        return {entered: false, reason: data?.reason ?? 'REQUEST_FAILED'};
    }

    const user = data.user;
    if (!user || !ENTITLED_STATUS_NAMES.has(user.statusName)) {
        console.log(`My Bundle entry not entitled: statusName=${user?.statusName}`);
        return {entered: false, reason: 'NO_ENTITLEMENT', statusName: user?.statusName};
    }

    localStorage.setItem('msisdn', user.msisdn);
    return {entered: true, user};
}

function stripSignedParams() {
    const params = new URLSearchParams(window.location.search);
    SIGNED_PARAM_NAMES.forEach((name) => params.delete(name));
    const query = params.toString();
    window.history.replaceState({}, document.title, `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
}
